import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { UkDateInput, isoToUk, ukValid } from "./UkDateInput";

const KINDS = [["policy", "Policy"], ["procedure", "Procedure"], ["statement", "Statement"], ["guidance", "Guidance"], ["privacy", "Privacy notice"],
  ["toolbox_talk", "Toolbox talk"], ["rams", "RAMS"], ["risk_assessment", "Risk assessment"], ["method_statement", "Method statement"]];
const sel = "mt-1 w-full h-10 rounded-md border border-slate-200 px-3 text-sm bg-white";

export function WsDetails({ ws, onSaved }) {
  const d = ws.document;
  const [m, setM] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    setM({ title: d.title || "", ref: d.ref || "", kind: d.kind || "policy", summary: d.summary || "",
      issue_date: isoToUk(d.issue_date), last_reviewed_date: isoToUk(d.last_reviewed_date), review_date: isoToUk(d.review_date),
      section_id: ws.section_ids[0] || "", ack_type: d.ack_type || "understand", is_reference: !!d.is_reference, ack_required: d.ack_required !== false });
  }, [d, ws.section_ids]);
  const set = (k, v) => setM((x) => ({ ...x, [k]: v }));
  const datesOk = ukValid(m.issue_date) && ukValid(m.last_reviewed_date) && ukValid(m.review_date);
  const save = async () => {
    if (busy) return; setBusy(true);
    const { section_id, ...rest } = m;
    try { await api.put(`/policies/authoring/${d.id}`, { ...rest, section_ids: section_id ? [section_id] : [] }); toast.success("Details saved"); onSaved(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };
  const L = "text-xs font-semibold text-slate-600";
  return (
    <div className="flex flex-col gap-3" data-testid="ws-details">
      <label className={L}>Title<Input data-testid="ws-title" value={m.title || ""} onChange={(e) => set("title", e.target.value)} className="mt-1" /></label>
      <div className="grid grid-cols-2 gap-3">
        <label className={L}>Reference<Input data-testid="ws-ref" value={m.ref || ""} onChange={(e) => set("ref", e.target.value)} className="mt-1" /></label>
        <label className={L}>Type<select data-testid="ws-kind" className={sel} value={m.kind} onChange={(e) => set("kind", e.target.value)}>{KINDS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></label>
      </div>
      <label className={L}>Section<select data-testid="ws-section" className={sel} value={m.section_id} onChange={(e) => set("section_id", e.target.value)}>
        <option value="">No section</option>{ws.sections.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select></label>
      <div className="grid grid-cols-3 gap-2">
        <label className={L}>Issue date<UkDateInput testid="ws-issue" value={m.issue_date} onChange={(v) => set("issue_date", v)} /></label>
        <label className={L}>Last reviewed<UkDateInput testid="ws-reviewed" value={m.last_reviewed_date} onChange={(v) => set("last_reviewed_date", v)} /></label>
        <label className={L}>Next review<UkDateInput testid="ws-next-review" value={m.review_date} onChange={(v) => set("review_date", v)} /></label>
      </div>
      <label className={L}>Summary<Textarea data-testid="ws-summary" value={m.summary || ""} onChange={(e) => set("summary", e.target.value)} className="mt-1 min-h-[60px]" /></label>
      <div className="flex flex-col gap-1.5 text-sm text-slate-700">
        <label className="flex items-center gap-2"><input type="checkbox" data-testid="ws-ack-required" checked={!!m.ack_required} onChange={(e) => set("ack_required", e.target.checked)} />Acknowledgement required</label>
        <label className="flex items-center gap-2"><input type="checkbox" data-testid="ws-reference" checked={!!m.is_reference} onChange={(e) => set("is_reference", e.target.checked)} />Reference only (excluded from compliance)</label>
        <label className={L}>Acknowledgement type<select data-testid="ws-ack-type" className={sel} value={m.ack_type} onChange={(e) => set("ack_type", e.target.value)}>
          <option value="understand">Read &amp; understood</option><option value="receipt">Receipt only</option></select></label>
      </div>
      <Button data-testid="ws-save-details" disabled={busy || !datesOk || !m.title} onClick={save} variant="outline" className="self-start">Save details</Button>
    </div>
  );
}
